import "./InfoCard.css";

const InfoCard = ({ imgSrc, spanTag, name, mapRespawn, color, drop, respawnTime = "", qty = ""}) => {
  return (
    <div className="card">
      <div className="card__inner">
        
        {/* Frente */}
        <div className="card__front">
          <div className="card__header">
            <h2 className="card-title">{name}</h2>
          </div>
          <div className="card__body">
            <img src={imgSrc} alt={name} />
            <span style={{ color: color }} className="card__body__date">
              {spanTag}
            </span>
          </div>
          <div style={{ backgroundColor: color }} className="card__footer">
            <div className="card__Footer__second">
              <p>{mapRespawn}</p> 
            </div>
          </div>
        </div>

        {/* Dorso */}
        <div className="card__back" style={{ backgroundColor: color }}>
          <div className="card__back__content">
            <h2 style={{ color: "white" }}>Drop de {name}</h2>
            {drop.map((drop)=>(
                <p>{drop}</p>
            ))}

            {respawnTime && <h4 style={{ color: "white" }}>Respawn: {respawnTime}</h4>}
            {qty && <h4 style={{ color: "white" }}>Cantidad: {qty}</h4>}
          </div>
        </div>

      </div>
    </div>
  );
};

export default InfoCard;
